// Curated dubstep / bass-focused slice of the EDC Las Vegas 2026 lineup.
// Source: https://lasvegas.electricdaisycarnival.com/lineup/
//
// Day + stage are pulled directly from the official "By Day" and "By Stage"
// breakdowns. Set times are best-guess slots based on typical Bass Pod /
// Cosmic Meadow programming (festival opens ~7pm, sunrise sets 5–6:30am).
// They're encoded as 24h "HH:mm" + duration in minutes so the scheduler can
// sort and group them; replace with official times when Insomniac drops the
// schedule.

export const EDC_DAYS = [
  { id: 'fri', label: 'Friday May 15', date: '2026-05-15' },
  { id: 'sat', label: 'Saturday May 16', date: '2026-05-16' },
  { id: 'sun', label: 'Sunday May 17', date: '2026-05-17' },
];

// Tag values mirror the EDC genre buckets we care about for this view.
// The user wants "mostly dubstep and bass", so this list is intentionally
// narrow — headliners + bass-leaning sets across Bass Pod, plus key bass
// drops at Cosmic Meadow / Stereo Bloom / Kinetic Field / Circuit Grounds.
const SETS = [
  // ===== FRIDAY =====
  { artist: 'ATLiens',                        stage: 'Bass Pod',        day: 'fri', start: '23:00', durationMin: 60, genre: 'dubstep' },
  { artist: 'Culture Shock',                  stage: 'Bass Pod',        day: 'fri', start: '21:30', durationMin: 60, genre: 'dnb' },
  { artist: 'Cyclops',                        stage: 'Bass Pod',        day: 'fri', start: '20:30', durationMin: 60, genre: 'dubstep' },
  { artist: 'Ghengar',                        stage: 'Bass Pod',        day: 'fri', start: '19:00', durationMin: 60, genre: 'riddim' },
  { artist: 'GorillaT',                       stage: 'Bass Pod',        day: 'fri', start: '00:00', durationMin: 60, genre: 'dubstep' },
  { artist: 'HEYZ',                           stage: 'Bass Pod',        day: 'fri', start: '01:00', durationMin: 60, genre: 'dubstep' },
  { artist: 'Kai Wachi',                      stage: 'Bass Pod',        day: 'fri', start: '02:00', durationMin: 60, genre: 'dubstep' },
  { artist: 'The Masquerade',                 stage: 'Bass Pod',        day: 'fri', start: '03:00', durationMin: 60, genre: 'bass' },
  { artist: 'MUZZ',                           stage: 'Bass Pod',        day: 'fri', start: '04:00', durationMin: 75, genre: 'dubstep' },
  { artist: 'RIOT',                           stage: 'Bass Pod',        day: 'fri', start: '22:00', durationMin: 60, genre: 'dubstep' },
  { artist: 'YDG',                            stage: 'Bass Pod',        day: 'fri', start: '18:00', durationMin: 60, genre: 'dubstep' },
  { artist: 'Ray Volpe',                      stage: 'Circuit Grounds', day: 'fri', start: '00:00', durationMin: 75, genre: 'dubstep' },
  { artist: 'Wooli',                          stage: 'Circuit Grounds', day: 'fri', start: '22:30', durationMin: 60, genre: 'dubstep' },

  // ===== SATURDAY =====
  { artist: 'Adventure Club (Throwback Set)', stage: 'Bass Pod',        day: 'sat', start: '00:00', durationMin: 75, genre: 'dubstep' },
  { artist: 'AVELLO B2B Dennett',             stage: 'Bass Pod',        day: 'sat', start: '18:30', durationMin: 60, genre: 'dubstep' },
  { artist: 'Delta Heavy',                    stage: 'Bass Pod',        day: 'sat', start: '21:00', durationMin: 60, genre: 'dnb' },
  { artist: 'Doctor P B2B Flux Pavilion B2B FuntCase', stage: 'Bass Pod', day: 'sat', start: '02:30', durationMin: 90, genre: 'dubstep' },
  { artist: 'Eptic B2B Space Laces',          stage: 'Bass Pod',        day: 'sat', start: '04:00', durationMin: 75, genre: 'dubstep' },
  { artist: 'Fallen with MC Dino',            stage: 'Bass Pod',        day: 'sat', start: '19:30', durationMin: 60, genre: 'dnb' },
  { artist: 'Getter',                         stage: 'Bass Pod',        day: 'sat', start: '23:00', durationMin: 60, genre: 'dubstep' },
  { artist: 'HOL!',                           stage: 'Bass Pod',        day: 'sat', start: '01:30', durationMin: 60, genre: 'riddim' },
  { artist: 'Hybrid Minds',                   stage: 'Bass Pod',        day: 'sat', start: '22:00', durationMin: 60, genre: 'dnb' },
  { artist: 'Mary Droppinz',                  stage: 'Bass Pod',        day: 'sat', start: '17:30', durationMin: 60, genre: 'bass' },
  { artist: 'Viperactive',                    stage: 'Bass Pod',        day: 'sat', start: '20:00', durationMin: 60, genre: 'dubstep' },
  { artist: 'Subtronics',                     stage: 'Kinetic Field',   day: 'sat', start: '01:30', durationMin: 75, genre: 'dubstep' },
  { artist: 'Sub Focus',                      stage: 'Kinetic Field',   day: 'sat', start: '23:30', durationMin: 75, genre: 'dnb' },

  // ===== SUNDAY =====
  { artist: 'A.M.C with MC Phantom',          stage: 'Bass Pod',        day: 'sun', start: '02:30', durationMin: 75, genre: 'dnb' },
  { artist: 'ÆON:MODE (Sunrise Set)',         stage: 'Bass Pod',        day: 'sun', start: '05:00', durationMin: 60, genre: 'dubstep' },
  { artist: 'AHEE B2B Liquid Stranger',       stage: 'Bass Pod',        day: 'sun', start: '01:00', durationMin: 75, genre: 'dubstep' },
  { artist: 'Boogie T B2B Distinct Motive',   stage: 'Bass Pod',        day: 'sun', start: '23:00', durationMin: 60, genre: 'dubstep' },
  { artist: 'EAZYBAKED',                      stage: 'Bass Pod',        day: 'sun', start: '21:30', durationMin: 60, genre: 'bass' },
  { artist: 'INFEKT B2B Samplifire',          stage: 'Bass Pod',        day: 'sun', start: '20:00', durationMin: 60, genre: 'dubstep' },
  { artist: 'Nightstalker with MC Dino',      stage: 'Bass Pod',        day: 'sun', start: '18:30', durationMin: 60, genre: 'dnb' },
  { artist: 'Peekaboo',                       stage: 'Bass Pod',        day: 'sun', start: '00:00', durationMin: 60, genre: 'dubstep' },
  { artist: 'Sippy',                          stage: 'Bass Pod',        day: 'sun', start: '17:00', durationMin: 60, genre: 'dubstep' },
  { artist: 'Virtual Riot',                   stage: 'Bass Pod',        day: 'sun', start: '03:30', durationMin: 75, genre: 'dubstep' },
  { artist: 'Whethan',                        stage: 'Bass Pod',        day: 'sun', start: '22:00', durationMin: 60, genre: 'bass' },
  { artist: 'GRiZ B2B Wooli',                 stage: 'Kinetic Field',   day: 'sun', start: '00:30', durationMin: 90, genre: 'bass' },
  { artist: 'Alison Wonderland',              stage: 'Cosmic Meadow',   day: 'sun', start: '22:30', durationMin: 75, genre: 'bass' },
  { artist: 'Black Tiger Sex Machine',        stage: 'Cosmic Meadow',   day: 'sun', start: '21:00', durationMin: 60, genre: 'bass' },
  { artist: 'Dabin',                          stage: 'Cosmic Meadow',   day: 'sun', start: '19:30', durationMin: 60, genre: 'bass' },
  { artist: 'San Holo (Wholesome Riddim Set)', stage: 'Cosmic Meadow',  day: 'sun', start: '23:30', durationMin: 60, genre: 'riddim' },
  { artist: 'William Black',                  stage: 'Cosmic Meadow',   day: 'sun', start: '18:00', durationMin: 60, genre: 'bass' },
  { artist: 'Hamdi',                          stage: 'Stereo Bloom',    day: 'sun', start: '00:30', durationMin: 75, genre: 'bass' },
  { artist: 'Skream',                         stage: 'Stereo Bloom',    day: 'sun', start: '02:00', durationMin: 90, genre: 'dubstep' },
];

// Stable ids derived from artist+day so they're consistent across renders
// and shareable as form submissions.
function makeId(s) {
  return [s.day, s.stage, s.artist]
    .join('|')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}

export const EDC_LINEUP = SETS.map((s) => ({ ...s, id: makeId(s) }));

export const EDC_STAGES_FROM_LINEUP = [
  ...new Set(EDC_LINEUP.map((s) => s.stage)),
];

export function getDayLabel(dayId) {
  return EDC_DAYS.find((d) => d.id === dayId)?.label ?? dayId;
}

// Returns "HH:mm" → e.g. "11:30 PM"
export function formatSetTime(hhmm) {
  if (!hhmm) return '';
  const [h, m] = hhmm.split(':').map(Number);
  const period = h < 12 ? 'AM' : 'PM';
  const display = ((h + 11) % 12) + 1;
  return `${display}:${String(m).padStart(2, '0')} ${period}`;
}

// Sorts within a single day so late-night sets feel "after" early evening,
// even though 02:00 < 19:00 numerically. We bucket 00:00–06:59 as "next day".
export function dayOrderKey(set) {
  const [h, m] = set.start.split(':').map(Number);
  const minutes = h * 60 + m;
  const wrapped = h < 7 ? minutes + 24 * 60 : minutes;
  return wrapped;
}

export function sortedForDay(dayId) {
  return EDC_LINEUP.filter((s) => s.day === dayId).sort(
    (a, b) => dayOrderKey(a) - dayOrderKey(b),
  );
}
